import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PackageInstalledAppsService } from '@services/packages/package-installed-apps.service';
import { DataTableEvent } from '../../../../components/data-table/data-table.component';

@Component({
    selector: 'app-package-installed-app-selection',
    templateUrl: './package-installed-app-selection.component.html',
    styleUrls: ['./package-installed-app-selection.component.scss'],
    providers: [PackageInstalledAppsService],
    standalone: false
})
export class PackageInstalledAppSelectionComponent implements OnInit {

  public columns = [
    { prop: 'translations.0.appTitle', name: 'appTitle' },
    { prop: 'packageId' },
    { validate: '_id', name: 'Assigned', icon: 'check_box' },
  ];
  public params;

  constructor(
    public packageInstalledAppService: PackageInstalledAppsService,
    private dialogRef: MatDialogRef<PackageInstalledAppSelectionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
  }

  ngOnInit() {
    console.log('welcome: ', this.data);
    this.params = { packageId: { $in: this.data.packageIds }, isSecured: true };
  }

  onSelect(event: DataTableEvent) {
    console.log('you have selected: ', event.row);
    let data = null;
    if (!event.row.isValidated) {
      data = event.row;
    }
    this.dialogRef.close(data);
  }

  abort() {
    this.dialogRef.close();
  }

}
